<template>
  <b-card class="mt-4 days-off-box">
    <h4 class="mb-4">Wykorzystane dni wolne</h4>


    <div v-if="list.length" class="days-off-list">
        <template v-for="(dayOff, index) of list" >
            <h2 v-if="isBreakPoint(index)" :key="'year_' + index">
                {{ yearText(dayOff) }}
            </h2>

            <b-card :key="'dayoff_' + index" class="mb-4" :class="{'bg-warning': isSpecialDay(dayOff)}">

                <div class="float-right">
                    <h1 class="text-right mb-0 mt-0" :class="{holiday: dayOff.weekendOnly}">{{ dayOff.items.length }}</h1>

                    <p v-if="dayOff.weekendOnly" class="holiday small">(tylko weekend)</p>

                    <p v-if="dayOff.weekendDays" class="small">(+{{ dayOff.weekendDays }} dni w weekend)</p>
                </div>

                <p>
                    <span class="mr-3"><b>Data: </b> {{ dateSpan(dayOff) }}</span>
                    
                    <span><b>Rodzaj:</b> {{ dayOff && dayOff.absence && dayOff.absence.name || 'Nieznany' }}</span>
                </p>
            
                <p class="mb-0"><b>Powód:</b> {{ dayOff.reason }}</p>
            </b-card>
        </template>
    </div>

    <p v-else>Brak wykorzystanych dni wolnych</p>
  </b-card>
</template>

<script>
import moment from 'moment';

import { DayOffResource } from '@/resources/dayOff.resource';

// [sobota, niedziela]
const weekendDayNumbers = [6, 0];

// Mapa słownikowa odmian "dzień wolny"
const dayOffMap = {
  1: 'dzień wolny',
  2: 'dni wolne',
  3: 'dni wolne',
  4: 'dni wolne'
};

// "Normalne" dni wolne do wykorzystania w ramach UOP
const normalDaysOff = [
  'Urlop wypoczynkowy',
  'Urlop na żądanie',
  'Urlop okolicznościowy',
  'Nieobecność usprawiedliwiona płatna (całodniowa)'
];

// Lista wykorzystanych dni wolnych pracownika
export default {
  name: 'DaysOffList',
  data() {
    return { list: [], year: new Date().getFullYear() };
  },

  methods: {
    // Pobiera listę dni wolnych
    getList() {
      return DayOffResource.list({ userId: parseInt(this.$route.params.id, 10) })
        .then(response => {
          const fullDaysOff = response.dayoffs
            .filter(dayOff => dayOff.hourStart === null && dayOff.minuteStart === null)
            .map(dayOff => {
              const itemsWithoutHolidays = dayOff.items
                .filter(Boolean)
                .filter(item => !weekendDayNumbers.includes(new Date(item.date).getDay()));

              if (itemsWithoutHolidays.length) {
                dayOff.weekendDays = dayOff.items.length - itemsWithoutHolidays.length;
                dayOff.items = itemsWithoutHolidays;
              } else {
                dayOff.weekendOnly = true;
              }

              return dayOff;
            });
          fullDaysOff.sort((dayA, dayB) => new Date(dayB.items[0].date) - new Date(dayA.items[0].date));
          this.list = fullDaysOff;
        })
        .catch(err => {
          console.warn('Error', err);
        });
    },

    // Formatuje datę
    dateSpan(dayOff) {
      if (dayOff.items.length === 1) {
        return moment(dayOff.items[0].date).format('DD.MM.YYYY');
      }
      const start = moment(dayOff.items[0].date).format('DD.MM.YYYY');
      const end = moment(dayOff.items[dayOff.items.length - 1].date).format('DD.MM.YYYY');
      return start + ' - ' + end;
    },

    // Sprawdza, czy zmienił się rok
    isBreakPoint(index) {
      if (!index) {
        return true;
      }

      const year = new Date(this.list[index].items[0].date).getFullYear();
      const previousYear = new Date(this.list[index - 1].items[0].date).getFullYear();
      return year !== previousYear;
    },

    // Tekst wyświetlany przy roku
    yearText(breakingDayOff) {
      const year = new Date(breakingDayOff.items[0].date).getFullYear();
      const yearDayOffs = this.list.filter(dayOff => new Date(dayOff.items[0].date).getFullYear() === year);

      const { days, specialDays, weekendDays } = yearDayOffs.reduce(
        (total, dayOff) => {
          if (dayOff.weekendOnly) {
            total.weekendDays += dayOff.items.length;
          } else if (this.isSpecialDay(dayOff)) {
            total.specialDays += dayOff.items.length;
          } else {
            total.days += dayOff.items.length;
          }

          if (dayOff.weekendDays) {
            total.weekendDays += dayOff.weekendDays || 0;
          }
          return total;
        },
        { days: 0, specialDays: 0, weekendDays: 0 }
      );

      let result = `${year} - ${this.daysOffText(days)}`;
      if (specialDays) {
        result += ` + ${this.daysOffText(specialDays)}*`;
      }
      if (weekendDays) {
        result += ` + ${this.daysOffText(weekendDays)} w weekendy`;
      }
      return result;
    },

    // Sformatowana liczba dni wolnych
    daysOffText(daysAmount) {
      return `${daysAmount} ${dayOffMap[daysAmount] || 'dni wolnych'}`;
    },

    // Czy dzień wolny specjalny, np. szkolenie, odbiór nadgodzin, itp.
    isSpecialDay(dayOff) {
      return !normalDaysOff.includes(dayOff && dayOff.absence && dayOff.absence.name);
    }
  },

  beforeMount() {
    this.getList();
  }
};
</script>

<style>
.days-off-box .card-body .days-off-list {
  max-height: 500px;
  overflow-y: auto;
}

.days-off-box .card-body .days-off-list .holiday {
  color: red;
}
</style>
